import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import { DocusignTemplateForm } from './DocusignTemplateForm'
import type { DocusignTemplateFormValues } from './DocusignTemplateForm.interface'

const FORM_ID = 'docusign-template-form'

interface Props {
  isOpen: boolean
  isSaving: boolean
  onSubmit(values: DocusignTemplateFormValues): void
  onClose(): void
}

const DocusignTemplateFormModalComponent = ({ isOpen, isSaving, onSubmit, onClose }: Props) => {
  return (
    <CommonModal
      isOpen={isOpen}
      title="Add contract template"
      // Wider than the default confirm-dialog width: this modal carries a form.
      className={tw`max-w-[480px]`}
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" disabled={isSaving} onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="dark"
            type="submit"
            form={FORM_ID}
            loading={isSaving}
            disabled={isSaving}
            data-testid="docusign-template-form-submit-button"
          >
            Create template
          </Button>
        </Fragment>
      }
    >
      <DocusignTemplateForm formId={FORM_ID} onSubmit={onSubmit} />
    </CommonModal>
  )
}

export const DocusignTemplateFormModal = memo(DocusignTemplateFormModalComponent)
